
import { Component, Vue, Ref } from 'vue-property-decorator'
import { WinpressService } from '@/services'
import FullLoading from '@/components/full_loading/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
// eslint-disable-next-line
import ScrollToType from '@/components/scroll_to/type'

// 当前文章分类的 storage 对象
export const typeStorage = {
    key: 'CUR_ARTICLE_TYPE',
    set(value: any) {
        sessionStorage.setItem(this.key, JSON.stringify(value))
    },
    get() {
        const result = sessionStorage.getItem(this.key)
        if (result) {
            return JSON.parse(result)
        }
        return false
    },
    clear() {
        sessionStorage.removeItem(this.key)
    }
}

@Component({
    name: 'media-store',
    components: {
        FullLoading,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType

    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true
    private typeList = []

    created() {
        this.$title('文章模块 | 麦媒云 - 庖丁')
    }
    mounted() {
        this.initData()    
    }
    async initData() {
        await this.getArticleTypes()
        this.isLoading = false
    }
    async getArticleTypes() {
        const result = await WinpressService.getArticleTypes()
        if (result.status === 200) {
            this.typeList = result.data
        }
    }
    onToArticleList(id: string | number) {
        window.open(`/content/winpress/article/list/${id}`)
    }
    onToTypeDetail(type: any) {
        // 存进 localStorage
        // 在详情页 created 获取 localStorage 里的数据
        // 组件销毁时删除该数据
        // 如果 curType 的 id 和 params.id 对不上
        // 则删除 curType, 并返回文章分类首页
        typeStorage.set(type)
        window.open(`/content/winpress/article/type/${type.id}`)
    }
    onDelete(id: string | number) {
        this.$confirm('正在执行删除操作, 你确定吗老铁?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            this.deleteType(id)
        })
    }

    async deleteType(id: string | number) {
        const params = { id }
        const result = await WinpressService.deleteArticleType(params)
        if (result.status === 200) {
            this.initData()
            return this.$msuccess('删除成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(() => {
            // todo
        })
    }
}
